/**
 * SectionInfoBubble — small "?" icon with hover/click popover explaining a section.
 * Wzorzec rozwiązuje feedback z transcript 2026-05: "jeśli ty mnie nie wytłumaczysz
 * o co chodzi, to ja mam wrażenie, że to nie jest mam, jakby nie wykorzystam".
 */
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

interface SectionInfoBubbleProps {
  title: string;
  description: string;
  example?: string;
  className?: string;
}

export function SectionInfoBubble({
  title,
  description,
  example,
  className,
}: SectionInfoBubbleProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-white/30 hover:text-white/70 transition-colors ${className ?? ""}`}
          aria-label={`Pomoc: ${title}`}
        >
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        className="bg-[#0a0c10] border-white/[0.1] text-white max-w-xs p-3 space-y-2"
      >
        <h4 className="text-xs font-semibold text-white">{title}</h4>
        <p className="text-[11px] text-white/70 leading-relaxed">{description}</p>
        {example && (
          <div className="pt-1.5 border-t border-white/[0.06]">
            <span className="text-[9px] uppercase tracking-wider text-white/40 font-semibold">
              Przykład
            </span>
            <p className="text-[10px] text-white/50 mt-1 leading-relaxed italic">{example}</p>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
